import {
	API_GET_SECRETARY_ACTIVE,
	API_GET_ALL_FOLDER_HELP,
	API_CREATE_FOLDER_HELP,
	API_GET_ASSIGNED_FOLDER_HELP,
	API_GET_WAITING_FOLDER_HELP,
	API_MANAGE_FOLDER_HELP_WAITING_LIST,
	API_VALIDATE_FOLDER_HELP,
	API_CANCEL_FOLDER_HELP,
	API_DONE_FOLDER_HELP,
	API_ABORT_SUPPORT_FOLDER_HELP,
	API_ACCEPT_SUPPORT_FOLDER_HELP,
	API_GET_STATS_FOLDER_HELP,
	API_POST_ASSIGN_FOLDER_HELP,
	API_POST_COMMENT_FOLDER_HELP,
	API_GET_STATS_DASHBOARD,
	API_GET_STATS_SECRETARY_HOME,
	API_GET_ALL_SCANS_ORDO,
	API_PATCH_NOTIFY_PREREGISTER,
	API_GET_CANCEL_REASONS,
	API_SEND_EMAIL_INCOMPLETE_FOLDER,
	API_GET_ALL_SECRETARIES,
	API_GET_SEC_SUPPORTED_FOLDERS,
} from "actions/folderHelp";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_GET_SECRETARY_ACTIVE]: {
		default: "/helpFolder/secretaries",
		v2: "/folder-help/secretaries",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_ALL_FOLDER_HELP]: {
		default: "/helpFolder/allFolders",
		v2: "/folder-help/allFolders",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_ASSIGNED_FOLDER_HELP]: {
		default: "/helpFolder/assigned",
		v2: "/folder-help/assigned",
		currentClient: DEFAULT_CLIENT,
	},
	[API_POST_ASSIGN_FOLDER_HELP]: {
		default: (folderHelpId) => `/helpFolder/${folderHelpId}/assign`,
		v2: (folderHelpId) => `/folder-help/${folderHelpId}/assign`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_POST_COMMENT_FOLDER_HELP]: {
		default: (folderHelpId) => `/helpFolder/${folderHelpId}/comment`,
		v2: (folderHelpId) => `/folder-help/${folderHelpId}/comment`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_WAITING_FOLDER_HELP]: {
		default: "/helpFolder/queue",
		v2: "/folder-help/queue",
		currentClient: DEFAULT_CLIENT,
	},
	[API_CREATE_FOLDER_HELP]: {
		default: (folderId) => `/helpFolder/${folderId}/create`,
		v2: (folderId) => `/folder-help/${folderId}/create`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ACCEPT_SUPPORT_FOLDER_HELP]: {
		default: (folderId) => `/helpFolder/${folderId}/support`,
		v2: (folderId) => `/folder-help/${folderId}/support`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_CANCEL_FOLDER_HELP]: {
		default: (folderHelpId) => `/helpFolder/${folderHelpId}/cancel`,
		v2: (folderHelpId) => `/folder-help/${folderHelpId}/cancel`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ABORT_SUPPORT_FOLDER_HELP]: {
		default: (folderId) => `/helpFolder/${folderId}/abort`,
		v2: (folderId) => `/folder-help/${folderId}/abort`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_VALIDATE_FOLDER_HELP]: {
		default: (folderId) => `/helpFolder/${folderId}/validate`,
		v2: (folderId) => `/folder-help/${folderId}/validate`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_DONE_FOLDER_HELP]: {
		default: (folderId) => `/helpFolder/${folderId}/done`,
		v2: (folderId) => `/folder-help/${folderId}/done`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_STATS_FOLDER_HELP]: {
		default: "/helpFolder/stats",
		v2: "/folder-help/stats",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_CANCEL_REASONS]: {
		default: "/helpFolder/cancelReasons",
		v2: "/folder-help/cancelReasons",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_STATS_DASHBOARD]: {
		default: "/helpFolder/dashboard",
		v2: "/folder-help/dashboard",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_STATS_SECRETARY_HOME]: {
		default: "/helpFolder/secretary/stats",
		v2: "/folder-help/secretary/stats",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_ALL_SECRETARIES]: {
		default: "/helpFolder/secretaries/all",
		v2: "/folder-help/secretaries/all",
		currentClient: DEFAULT_CLIENT,
	},
};
export function getSecretariesActive() {
	const version = getVersion(API_GET_SECRETARY_ACTIVE);
	return {
		type: API_GET_SECRETARY_ACTIVE,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
			},
		},
	};
}

export function getAllFolderHelp(page = 1, done = false, preregister = true, nbItems = 50, withInit = false) {
	const version = getVersion(API_GET_ALL_FOLDER_HELP);
	return {
		type: API_GET_ALL_FOLDER_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				params: {
					page: page,
					nbItems: nbItems,
					done: done,
					preregister: preregister,
					withInit: withInit,
				},
			},
		},
	};
}

export function manageWaitingList() {
	return {
		type: API_MANAGE_FOLDER_HELP_WAITING_LIST,
		payload: {
			request: {
				url: `/helpFolder/manage`,
			},
		},
	};
}

export function getAssignedToMeFolderHelp(myCenter = false) {
	const version = getVersion(API_GET_ASSIGNED_FOLDER_HELP);
	return {
		type: API_GET_ASSIGNED_FOLDER_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: `${version.path}${myCenter ? "/center" : ""}`,
			},
		},
	};
}

export function postAssignToMe(folderHelpId) {
	const version = getVersion(API_POST_ASSIGN_FOLDER_HELP);
	return {
		type: API_POST_ASSIGN_FOLDER_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: typeof version.path === 'function' ? version.path(folderHelpId) : version.path,
				method: "POST",
			},
		},
	};
}
export function postComment(folderHelpId, comment) {
	const version = getVersion(API_POST_COMMENT_FOLDER_HELP);
	return {
		type: API_POST_COMMENT_FOLDER_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: typeof version.path === 'function' ? version.path(folderHelpId) : version.path,
				method: "POST",
				data: { comment: comment },
			},
		},
	};
}

export function getWaitingFolderHelp() {
	const version = getVersion(API_GET_WAITING_FOLDER_HELP);
	return {
		type: API_GET_WAITING_FOLDER_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
			},
		},
	};
}

export function createFolderHelp(
	folderId,
	analyzes,
	other,
	comment,
	dataPatient,
	barcodes,
	center,
	deposit = null,
	isTvSec = true,
	isDeposit = false
) {
	const version = getVersion(API_CREATE_FOLDER_HELP);
	return {
		type: API_CREATE_FOLDER_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: typeof version.path === 'function' ? version.path(folderId) : version.path,
				method: "POST",
				data: {
					analyzes: analyzes,
					other: other,
					comment: comment,
					barcodes: barcodes,
					center: center,
					dataPatient: dataPatient,
					deposit: deposit,
					isTvSec: isTvSec,
					isDeposit: isDeposit,
				},
			},
		},
	};
}

export function acceptSupportFolderHelp(folderId) {
	const version = getVersion(API_ACCEPT_SUPPORT_FOLDER_HELP);
	return {
		type: API_ACCEPT_SUPPORT_FOLDER_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: typeof version.path === 'function' ? version.path(folderId) : version.path,
				method: "POST",
			},
		},
	};
}

export function cancelFolderHelp(folderHelpId, comment, reason = 0) {
	const version = getVersion(API_CANCEL_FOLDER_HELP);
	return {
		type: API_CANCEL_FOLDER_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: typeof version.path === 'function' ? version.path(folderHelpId) : version.path,
				method: "POST",
				data: {
					comment: comment,
					cancelReason: reason,
				},
			},
		},
	};
}

export function abortSupportFolderHelp(folderId, comment, cancel, reason = 0) {
	const version = getVersion(API_ABORT_SUPPORT_FOLDER_HELP);
	return {
		type: API_ABORT_SUPPORT_FOLDER_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: typeof version.path === 'function' ? version.path(folderId) : version.path,
				method: "POST",
				data: {
					comment: comment,
					cancel: cancel,
					cancelReason: reason,
				},
			},
		},
	};
}

export function validateFolderHelp(folderId, comment, urgent) {
	const version = getVersion(API_VALIDATE_FOLDER_HELP);
	return {
		type: API_VALIDATE_FOLDER_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: typeof version.path === 'function' ? version.path(folderId) : version.path,
				method: "POST",
				data: {
					comment: comment,
				},
			},
		},
	};
}

export function doneFolderHelp(folderId) {
	const version = getVersion(API_DONE_FOLDER_HELP);
	return {
		type: API_DONE_FOLDER_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: typeof version.path === 'function' ? version.path(folderId) : version.path,
				method: "GET",
			},
		},
	};
}
///helpFolder/stats accessible sans authentification uniquement pour le dashboard
export function getStatsFolderHelp() {
	const version = getVersion(API_GET_STATS_FOLDER_HELP);
	return {
		type: API_GET_STATS_FOLDER_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "GET",
			},
		},
	};
}

export function getStatsDashboard(startDate, endDate) {
	const version = getVersion(API_GET_STATS_DASHBOARD);
	return {
		type: API_GET_STATS_DASHBOARD,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "GET",
				params: { startDate, endDate },
			},
		},
	};
}
export function getStatsSecretaryHome() {
	const version = getVersion(API_GET_STATS_SECRETARY_HOME);
	return {
		type: API_GET_STATS_SECRETARY_HOME,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "GET",
			},
		},
	};
}

export function getAllScansOrdo() {
	return {
		type: API_GET_ALL_SCANS_ORDO,
		payload: {
			request: {
				url: `/scan/ordos/`,
				method: "GET",
			},
		},
	};
}

export function notifyMeForPreregister(id) {
	return {
		type: API_PATCH_NOTIFY_PREREGISTER,
		payload: {
			request: {
				url: `/helpfolder/notify/${id}`,
				method: "PATCH",
			},
		},
	};
}

export function getFolderHelpCancelReasons() {
	const version = getVersion(API_GET_CANCEL_REASONS);
	return {
		type: API_GET_CANCEL_REASONS,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "GET",
			},
		},
	};
}
export function getLastFoldersSupported() {
	return {
		type: API_GET_CANCEL_REASONS,
		payload: {
			request: {
				url: `/helpFolder/myHisto`,
				method: "GET",
			},
		},
	};
}

export function sendEmailIncompleteFolder(cancelReason, comment, id) {
	return {
		type: API_SEND_EMAIL_INCOMPLETE_FOLDER,
		payload: {
			request: {
				url: `/preregister/${id}/incomplete`,
				method: "POST",
				data: { cancelReason, comment },
			},
		},
	};
}

export function getAllSecretaries() {
	const version = getVersion(API_GET_ALL_SECRETARIES);
	return {
		type: API_GET_ALL_SECRETARIES,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "GET",
			},
		},
	};
}

export function getSecSupportedFolders(id, startDate, endDate) {
	return {
		type: API_GET_SEC_SUPPORTED_FOLDERS,
		payload: {
			request: {
				url: `/helpFolder/secretary/${id}/supported`,
				method: "GET",
				params: { startDate, endDate },
			},
		},
	};
}
